export const SUGGESTION_ACTIONS_QUERY_KEY = "suggestion-actions:list";
